import { createResource } from "@evergis/react-fetching";
import { api as evergisApi } from "../evergis/api";

export const spatialReferences = createResource(
  () => async api => {
    return {
      data: await api.spatialReference.getAvailiableCs(),
    };
  },
  { injected: evergisApi },
);

export const getProj4Representation = createResource(
  (name: string) => async api => {
    return {
      data: await api.spatialReference.getProj4Representation(name),
    };
  },
  { injected: evergisApi },
);
